import type { IssueMetaIssueLink } from '@atlassian/jira-polaris-remote-issue/src/controllers/crud/types.tsx';
import { JPD_CONNECTION_ISSUE_LINK_TYPE } from '../../constants.tsx';

export const findConnectionIssueLink = (
	id: string,
	{ typeName, inwardIssue, outwardIssue }: IssueMetaIssueLink,
) =>
	typeName === JPD_CONNECTION_ISSUE_LINK_TYPE &&
	(outwardIssue.id.toString() === id || inwardIssue.id.toString() === id);
